import { render, staticRenderFns } from "./IndexNotifications.vue?vue&type=template&id=6292c3b6&scoped=true&"
import script from "./IndexNotifications.vue?vue&type=script&lang=js&"
export * from "./IndexNotifications.vue?vue&type=script&lang=js&"
import style0 from "./IndexNotifications.vue?vue&type=style&index=0&id=6292c3b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6292c3b6",
  null
  
)

export default component.exports